module.exports = __webpack_public_path__ + "static/media/dydx.49cd3a15.svg";